export const COLUMN_HEADINGS = ['Email', 'First Name', 'Last Name', 'Ticket Type', 'Quantity', 'Options'];
export const COLUMN_MIN_WIDTH = [200, 200, 200, 200, 40, 40];
export const COLUMN_HEADINGS_MOBILE = ['', 'Email', 'First Name', 'Last Name', 'Ticket Type', 'Quantity'];
export const COLUMN_MIN_WIDTH_MOBILE = [60, 200, 150, 150, 150, 100];

export const GRID_COLUMNS = `repeat(${COLUMN_HEADINGS.length}, 1fr)`;
export const GRID_COLUMNS_MIN = `repeat(${COLUMN_HEADINGS.length}, auto)`;
